module.exports = __webpack_public_path__ + "static/media/no_main_img.e5dd0015.svg";